export const defaultEditorState =
    '{"root":{"children":[{"children":[],"direction":null,"format":"","indent":0,"type":"adam_paragraph","version":1}],"direction":null,"format":"","indent":0,"type":"root","version":1}}'
